import * as React from "react";
import { AutoCompleteInput, Checkbox, Input } from "uxp/components";
import { findAvailableFields, IUIPropertyDefinition } from "../../../common/common";
import { CustomColorPicker, Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyGroupTitle, PropertyTitle } from "../../../common/ui-props/common";
import { WidgetDesignerPillInput } from "../../../common/pill-input/PillInput";
import jp from 'jsonpath'
import IconEditor from "../../../common/icon-selector/IconEditor";
export interface ITwoValueWidgetProps {
    firstValueField: string;
    secondValueField: string;
    firstColor: string;
    secondColor: string;
    circleColor: string;
    circleIconColor: string;
    firstValueLabel: string;
    secondValueLabel: string;
    firstValueLabelColor: string;
    secondValueLabelColor: string;
    refreshInterval: 60000;
    circleIcon: '';
    channel: '';
    secondValueIsTotal: boolean;
}


export function TwoValueWidgetProperty(mode: 'first' | 'second' | 'all' | 'circle', title: string, props: ITwoValueWidgetProps): IUIPropertyDefinition<ITwoValueWidgetProps> {
    return {
        defaults: props,
        render: (props, uxpContext, contextData) => {

            let _props = props.uiProps

            let possibleValues = {};
            findAvailableFields(props.parentUIProps.source, props.parentUIProps.datasources, possibleValues);
            let pv = Object.keys(possibleValues);
            pv.sort();

            return <>

                {
                    (mode == 'all') && <PropertyContainer>
                        <PropertyContainerTitle>{title}</PropertyContainerTitle>
                        <PropertyGroup>


                            <Property>
                                <PropertyTitle>Refresh Interval (ms)</PropertyTitle>
                                <Input
                                    type="number"
                                    value={_props?.refreshInterval?.toString() || '0'}
                                    onChange={s => {
                                        let num = Number(s) || 0
                                        jp.apply(_props, '$.refreshInterval', () => (num))
                                        props.onChange(Object.assign({}, _props));
                                    }}
                                />

                            </Property>

                            <Property>
                                <PropertyTitle>Channel Name</PropertyTitle>
                                <Input
                                    value={_props?.channel || ''}
                                    onChange={s => {
                                        jp.apply(_props, '$.channel', () => (s))
                                        props.onChange(Object.assign({}, _props));
                                    }}
                                />

                            </Property>




                        </PropertyGroup>
                    </PropertyContainer>
                }
                {
                    (mode == 'first' || mode == 'all') && <PropertyContainer>
                        <PropertyContainerTitle>Left Section</PropertyContainerTitle>
                        <PropertyGroup>
                            <Property>
                                <PropertyTitle>Value Field</PropertyTitle>
                                <AutoCompleteInput
                                    value={_props.firstValueField || ''}
                                    onChange={s => {
                                        jp.apply(_props, '$.firstValueField', () => (s))
                                        props.onChange(Object.assign({}, _props));
                                    }}
                                    className="widget-designer-input"
                                    options={pv}
                                />

                            </Property>
                            <Property>
                                <PropertyTitle>Background Color</PropertyTitle>
                                <CustomColorPicker contextData={props.contextData}
                                    color={_props.firstColor || 'white'}
                                    onChange={s => {
                                        jp.apply(_props, '$.firstColor', () => (s))
                                        props.onChange(Object.assign({}, _props));
                                    }}

                                />

                            </Property>
                            <Property>
                                <PropertyTitle>Label</PropertyTitle>
                                <WidgetDesignerPillInput
                                    value={_props.firstValueLabel || ''}
                                    onChange={s => {
                                        jp.apply(_props, '$.firstValueLabel', () => (s))
                                        props.onChange(Object.assign({}, _props));
                                    }}
                                    contextData={contextData}
                                />

                            </Property>

                            <Property>
                                <PropertyTitle>Label Color</PropertyTitle>
                                <CustomColorPicker contextData={props.contextData}
                                    color={_props.firstValueLabelColor || 'white'}
                                    onChange={s => {
                                        jp.apply(_props, '$.firstValueLabelColor', () => (s))
                                        props.onChange(Object.assign({}, _props));
                                    }}

                                />

                            </Property>
                        </PropertyGroup>
                    </PropertyContainer>
                }

                {
                    (mode == 'second' || mode == 'all') && <PropertyContainer>
                        <PropertyContainerTitle>Right Section</PropertyContainerTitle>
                        <PropertyGroup>
                            <Property>
                                <PropertyTitle>Value Field</PropertyTitle>
                                <AutoCompleteInput
                                    value={_props.secondValueField || ''}
                                    onChange={s => {
                                        jp.apply(_props, '$.secondValueField', () => (s))
                                        props.onChange(Object.assign({}, _props));
                                    }}
                                    className="widget-designer-input"
                                    options={pv}
                                />

                            </Property>
                            <Property>
                                <PropertyTitle>Background Color</PropertyTitle>
                                <CustomColorPicker contextData={props.contextData}
                                    color={_props.secondColor || 'white'}
                                    onChange={s => {
                                        jp.apply(_props, '$.secondColor', () => (s))
                                        props.onChange(Object.assign({}, _props));
                                    }}

                                />

                            </Property>

                            <Property>
                                <PropertyTitle>Label</PropertyTitle>
                                <WidgetDesignerPillInput
                                    value={_props.secondValueLabel || ''}
                                    onChange={s => {
                                        jp.apply(_props, '$.secondValueLabel', () => (s))
                                        props.onChange(Object.assign({}, _props));
                                    }}
                                    contextData={contextData}
                                />

                            </Property>
                            <Property>
                                <PropertyTitle>Label Color</PropertyTitle>
                                <CustomColorPicker contextData={props.contextData}
                                    color={_props.secondValueLabelColor || 'white'}
                                    onChange={s => {
                                        jp.apply(_props, '$.secondValueLabelColor', () => (s))
                                        props.onChange(Object.assign({}, _props));
                                    }}

                                />

                            </Property>

                            <Property>
                                <Checkbox
                                    checked={_props?.secondValueIsTotal}
                                    onChange={s => {
                                        jp.apply(_props, '$.secondValueIsTotal', () => (s))
                                        props.onChange(Object.assign({}, _props));
                                    }}
                                    label="Second value represents total"
                                />

                            </Property>
                        </PropertyGroup>
                    </PropertyContainer>
                }

                {
                    (mode == 'circle' || mode == 'all') && <PropertyContainer>
                        <PropertyContainerTitle>Circle</PropertyContainerTitle>
                        <PropertyGroup>
                            <Property>
                                <PropertyTitle>Circle Color</PropertyTitle>
                                <CustomColorPicker contextData={props.contextData}
                                    color={_props.circleColor || 'black'}
                                    onChange={s => {
                                        jp.apply(_props, '$.circleColor', () => (s))
                                        props.onChange(Object.assign({}, _props));
                                    }}

                                />

                            </Property>
                            <Property>
                                <PropertyTitle>{'Icon'}</PropertyTitle>
                                <IconEditor
                                    value={_props.circleIcon || ''}
                                    onChange={s => {
                                        jp.apply(_props, '$.circleIcon', () => (s))
                                        props.onChange(Object.assign({}, _props));
                                    }}
                                />
                            </Property>
                            <Property>
                                <PropertyTitle>Icon Color</PropertyTitle>
                                <CustomColorPicker contextData={props.contextData}
                                    color={_props.circleIconColor || 'white'}
                                    onChange={s => {
                                        jp.apply(_props, '$.circleIconColor', () => (s))
                                        props.onChange(Object.assign({}, _props));
                                    }}

                                />

                            </Property>

                        </PropertyGroup>
                    </PropertyContainer>
                }

            </>
        }
    };
}
